export default {
  title: {
    notFound: 'No encontrada',
    error: 'Error',
    legal: 'Aviso Legal',
    privacy: 'Política de Privacidad',
    cookies: 'Política de Cookies',
    construction: 'En construcción',
    error404: 'No encontrada'
  },
  message: {
    generic: {
      loadingData: 'Cargando datos',
      moreInfo: 'Más información',
      error: {
        notFound1: 'Ups! ¿Estás perdido?',
        notFound2: 'La página que está buscando no existe.'
      },
      webConstruction: 'Página en construcción'
    }
  },
  language: {
    en: 'Inglés',
    es: 'Español'
  },
  ui: {
    button: {
      legalWarning: 'Aviso legal',
      privacyPolicy: 'Política de privacidad',
      cookiesPolicy: 'Política de cookies'
    }
  },
  error: {
    undefined: 'Ups... ¡Algo salió mal!',
    notFound: 'Esta página no existe'
  }
};
